import React, { Component } from 'react'
import * as mat from 'material-ui'
import { connect } from 'react-redux';
import './style.css'
import GoOrganization from 'react-icons/lib/go/organization'
import GoHome from 'react-icons/lib/go/home'
// import dummy from '../images/faculty.png';
// import Dropzone from 'react-dropzone';
import { CheckAuthConfirmation } from '../../action/authAction'

class ConfirmationInstant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key: '',
            userName: '',
            phone: '',
            schoolName: '',
            students: '',
            schoolAddress: '',
            errormessage: '',
            value:''
        }
        this.handleChange = this.handleChange.bind(this);

    }
 
    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    CheckSignUp() {
        let refs = this.refs
        let obj = { keys: refs.key.value, userName: refs.userName.value, phone: refs.phone.value, schoolName: refs.schoolName.value, students: refs.students.value, schoolAddress: refs.schoolAddress.value, schoolType: this.state.value}
        if (obj.keys === null || obj.userName === null || obj.phone === null || obj.schoolName === null || obj.students === null || obj.schoolAddress === null || obj.schoolType === null) { this.setState({ errormessage: 'All fields are required' }) }
        else { this.setState({ errormessage: '' }); 
        console.log(obj,'check select')
        this.props.CheckAuthConfirmation(this.props.info, obj); }
    }
    render() {
        const {
            error,
            Loader
        } = this.props;
        // console.log('info', this.props.info)
        return (
            <div className='profile'>
                {/* <div > */}
                <mat.Card zDepth={0} className='col-md-6 col-md-offset-3 col-xs-10 col-xs-offset-1'>
                    <mat.AppBar
                        title='Enter passcode'
                        titleStyle={{ textShadow: '0px 1px 2px #cccccc', fontSize: '2em', fontWeight: 'normal', color: '#000000' }}
                        showMenuIconButton={false}
                        style={{ backgroundColor: 'white' }}
                        zDepth={0}
                        className='text-center heading'
                    />
                    <mat.CardText >
                        <mat.Divider />
                    </mat.CardText >
                    <mat.CardText >


                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                            <input
                                required
                                ref="userName"
                                className="form-control"
                                placeholder="Username"

                            />
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-earphone"></i></span>
                            <input
                                required
                                ref="phone"
                                className="form-control"
                                placeholder="Enter Phone Number"
                                type='number'
                            />
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-education"></i></span>
                            <input
                                required
                                ref="schoolName"
                                className="form-control"
                                placeholder="Enter School Name"
                            />
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><GoOrganization /></span>
                            <input
                                required
                                ref="students"
                                className="form-control"
                                placeholder="Enter No. of Students"
                                type='number'
                            />
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><GoOrganization /></span>

                            <select className="form-control"  value={this.state.value} onChange={this.handleChange}>
                                <option value="independent">Independent</option>
                                <option value="government">Government</option>
                                <option value="autonomous">Autonomous</option>
                                <option value="private">Private</option>
                                <option value="international">International</option>
                            </select>
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><GoHome /></span>
                            <input
                                required
                                ref="schoolAddress"
                                className="form-control"
                                placeholder="Enter School Address"
                            />
                        </div>
                        <br />
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-lock"></i></span>
                            <input
                                required
                                ref="key"
                                className="form-control"
                                type='password'
                                placeholder="Enter Passcode"
                                maxLength={8}
                            />
                        </div>
                        <br />
                        <div className='col-md-12 text-center' style={{ color: 'red', fontSize: 18 }}>
                            {this.state.errormessage}
                        </div>
                        <div className='col-md-12 text-center' style={{ color: 'red', fontSize: 18 }}>
                            {error}
                        </div>
                        <div className="btn-group btn-group-lg btn-group-justified">
                            {(Loader === false) ? (
                                <a onClick={this.CheckSignUp.bind(this)} className="btn btn-info" >Verify Passcode</a>
                            ) : (
                                    <div className='text-Center'>
                                        <mat.LinearProgress mode="indeterminate" color='#1e5a89' />
                                    </div>
                                )}
                        </div>
                    </mat.CardText>
                </mat.Card>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        info: state.authReducers.userDetails,
        Loader: state.authReducers.passCode,
        // sucess: state.AdminReducer.ErrorMess,
        error: state.authReducers.PassError,
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        CheckAuthConfirmation: (info, key) => {
            dispatch(CheckAuthConfirmation(info, key));
        },
        // SaveEditProfile: (file) => {
        //     dispatch(SaveEditProfile(file));
        // }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationInstant);
// export default ConfirmationInstant


// WEBPACK FOOTER //
// ./src/component/auth/confirmation.jsx